<template>
    <nav
        id="nav"
        class="navbar is-fixed-top"
        role="navigation"
        aria-label="main navigation"
    >
        <div class="navbar-brand">
            <div class="navbar__title-container">
                <img class="navbar__image" src="@/assets/delivery.svg" alt="DailyFruits Delivery App">
                <slot name="title"></slot>
            </div>
            <div
                class="navbar__title-container"
                :class="{'navbar__title-container--hidden': burger}"
            >
                <slot name="search"></slot>
            </div>
            <div class="navbar-item navbar-item--title">
                <slot name="deliveries"></slot>
            </div>
            <a
                role="button"
                class="navbar-burger burger"
                :class="{'is-active':burger}"
                aria-label="menu"
                aria-expanded="false"
                data-target="navbarBasicExample"
                @click.prevent="burger = !burger"
            >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>
        <transition name="slide-right">
            <div
                class="navbar-menu is-active"
                v-if="burger"
                @click="burger = false"
            >
                <div class="navbar-start">
                    <a
                        class="navbar-item"
                        href="#"
                        @click.prevent="$router.push('/')"
                    >
                        <img class="logo" src="@/assets/logo-menu.png" alt="DailyFruits Delivery App">
                    </a>
                </div>
                <div class="navbar-end">
                    <router-link class="navbar-item" to="/deliveries">Twoje dostawy</router-link>
                    <a
                        href="#"
                        @click.prevent.stop="downloadDemand({})"
                        download="docs"
                        class="navbar-item"
                        :class="{'navbar-item--loading':isPdfLoading}"
                        data-name="dokument"
                    >
                        Twoje zapotrzebowanie
                        <span class="icon button__icon">
                            <svg-icon type="loader" class="svg-icon--active" />
                        </span>
                    </a>
                    <router-link class="navbar-item" to="/delivered">Dostarczone dostawy</router-link>
                    <router-link class="navbar-item" to="/deliveries-planning">Planowanie dostaw</router-link>
                    <router-link class="navbar-item" to="/deliveries-archive">Archiwalne dostawy</router-link>
                    <router-link class="navbar-item" to="/complaints">Reklamacje</router-link>
                    <router-link class="navbar-item" to="/home-orders">DF Home</router-link>
                    <router-link class="navbar-item" to="/scanner">Skaner kodów</router-link>
                    <router-link class="navbar-item" to="/logout">Wyloguj</router-link>
                </div>
            </div>
        </transition>
    </nav>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
export default {
    components: {
      'svg-icon': SvgIcon
    },
    data() {
        return {
            burger: false,
            lastScrollPosition: 0
        }
    },
    computed: {
        isPdfLoading() {
          return this.$store.getters.isLoadingPdf
        },
        isNavbarHidden() {
            return this.$store.getters.isNavbarHidden
        },
        isScrollingToDelivery() {
            return this.$store.getters.isScrollingToDelivery
        }
    },
    methods: {
        downloadDemand() {
          this.$store.dispatch('fetchDemandsPdf', {})
        },
        onScroll() {
            // het the current scroll position
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
            // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than height of navbar
            if (currentScrollPosition < 59 && !this.isScrollingToDelivery) {
                this.$store.dispatch('hideNavbar', false)
                return
            }
            // show or hide the navbar
            if(currentScrollPosition > this.lastScrollPosition){
                if(!this.isNavbarHidden){
                    this.$store.dispatch('hideNavbar', true)
                }
            } else {
                // show navbar only when it's not auto scroll after toggle
                if(this.isNavbarHidden && !this.isScrollingToDelivery){
                    this.$store.dispatch('hideNavbar', false)
                }
            }
            // set the current scroll position as the last scroll position
            this.lastScrollPosition = currentScrollPosition
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.onScroll)
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/variables"

.navbar
    transition: transform $normal
    will-change: transform
    &__title-container
        margin-right: 1rem
        font-size: $size-7
        &--hidden
            display: none
    &__image
        max-height: 2rem
        display: block
        margin: auto
        margin-top: 1rem
        margin-bottom: .7rem
    &--hidden
        transform: translateY(-5rem)
.navbar-brand
    flex-direction: row-reverse
    width: 100%
    justify-content: space-between
.navbar-burger
    margin-left: 0
    z-index: 1
    cursor: pointer
    span
        height: 3px
        background-color: $green
        transition: background-color $normal
        left: calc(50% - 10px)
        width: 20px
        border-radius: 5px
    &.is-active
        background-color: transparent
        span
            background-color: $white
.navbar-menu
    background-color: $green
    position: absolute
    width: 100%
    height: 100vh
    max-height: none !important
    overflow: hidden
    top: 0
    &.is-active
        display: block !important
    .navbar-start
        position: absolute
        width: 100%
        .navbar-item
            img
                max-height: 50%
    .navbar-end
        display: flex
        justify-content: center
        flex-direction: column
        align-items: center
        height: 100%
    .navbar-item
        text-transform: uppercase
        padding: 1.5rem 2rem
        width: 100%
        text-align: center
        font-size: $size-4
        font-weight: 600
        &:focus,
        &:focus-within,
        &:hover,
        &:focus + .navbar-item,
        &:focus-within + .navbar-item,
        &:hover + .navbar-item,
        &.is-active + .navbar-item
            &::after
                display: none !important
        &:not(:first-child)::after
            content: ""
            width: 54%
            height: 1px
            display: block
            position: absolute
            background-color: $grey
            left: 0
            right: 0
            top: 0
            margin: auto
            // border-top: 1px solid $grey
.navbar-item
    &--title
        color: $text
        text-align: center
        display: flex
        align-items: center
        justify-content: center
        font-weight: 300
        flex-grow: 1
    &--loading
        .button__icon
            display: inline-block

</style>
